import React from 'react';
import { Box } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { StylovyzeTooltip } from '@innovyze/stylovyze';

// Small grey info icon with a tooltip, safe to place inside a
// FormControlLabel label: clicking it must not toggle the radio/checkbox.
const swallowClick = (event: React.MouseEvent) => {
	event.preventDefault();
	event.stopPropagation();
};

export const LabelInfoTip = ({
	text,
	dataCy,
}: {
	text: string;
	dataCy?: string;
}) => (
	<StylovyzeTooltip content={text} padded>
		<Box
			component="span"
			data-cy={dataCy}
			onClick={swallowClick}
			sx={{ display: 'inline-flex', cursor: 'default' }}>
			<InfoOutlined sx={{ fontSize: 15, color: '#b3bac4' }} />
		</Box>
	</StylovyzeTooltip>
);
